import { render, staticRenderFns } from "./reduce-amount.vue?vue&type=template&id=6f14d0cf&scoped=true"
import script from "./reduce-amount.vue?vue&type=script&lang=js"
export * from "./reduce-amount.vue?vue&type=script&lang=js"
import style0 from "./reduce-amount.vue?vue&type=style&index=0&id=6f14d0cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f14d0cf",
  null
  
)

export default component.exports